<!-- 总评center地图 -->
<style lang="stylus" scoped>
.map-wrap
  position relative
.map-type-wrap
  position absolute
  bottom: 40px
  left 50px
.map-type
  margin-bottom 20px
  color #77CAD8
  font-size 10px
  text-align center
  img
    width 100%
    height 100%
  div
    width:52px;
    height:33px;
    margin-bottom 10px;
    border:1px solid rgba(14, 202, 247, 1);
    border-radius:4px;
.map
  width 655px
  height 630px
  margin 0 auto
  .main
    width 100%
    height 100%
</style>

<template>
  <div class="map-wrap">
    <!-- <div class="map-type-wrap">
      <div class="map-type">
        <div><img src="static/img/dashboard/map-type-1.png" alt=""></div>
        <p>卫星图</p>
      </div>
      <div class="map-type">
        <div><img src="static/img/dashboard/map-type-2.png" alt=""></div>
        <p>2D平面图</p>
      </div>
      <div class="map-type">
        <div><img src="static/img/dashboard/map-type-3.png" alt=""></div>
        <p>3D视图</p>
      </div>
    </div> -->
    <div class="map" @click="jumpChild">
      <div class="main"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: {
    areaName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      myChart: {}
    }
  },
  components: {
  },
  methods: {
    jumpChild() {
      this.$router.push('/base');
    }
  },
  mounted: function () {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.map .main'))
    axios.get(`static/data/百色市/${this.areaName}.json`).then(res => {
      const geoCoordMapList = res.data.features[0].geometry.coordinates[0][0]
      // 引入地区地图
      echarts.registerMap(this.areaName, res.data)
      // 每个地区的坐标
      const geoCoordMap = {
        '广西百色翠丰特色农产品有限责任公司': [106.887345, 24.1138430000001],
        '广西百色盛泰和农业有限公司': [106.933768339844, 23.9298854804688],
        '广西田阳新靖田农产品贸易有限公司 ': [107.03298953125, 23.875044171875],
        '广西田阳古鼎香农产品综合批发市场有限公司 ': [107.003172636719, 23.6282497382813],
        '广西田阳穗丰园农产品贸易有限公司 ': [106.592535429688, 23.4990334296876]
      }

      // 每个地区的设备数量值
      const data = [
        {name: '广西百色翠丰特色农产品有限责任公司', value: 10},
        {name: '广西百色盛泰和农业有限公司', value: 20},
        {name: '广西田阳新靖田农产品贸易有限公司 ', value: 20},
        {name: '广西田阳古鼎香农产品综合批发市场有限公司 ', value: 20},
        {name: '广西田阳穗丰园农产品贸易有限公司 ', value: 20}
      ]

      const convertData = function (data) {
        const res = []
        for (let i = 0; i < data.length; i++) {
          const geoCoord = geoCoordMap[data[i].name]
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            })
          }
        }
        return res
      }

      function tooltipCharts() {
        const tooltipDom = document.getElementById('tooltipPieId');
        if (tooltipDom) {
          const tooltipCharts = echarts.init(document.getElementById('tooltipPieId'));
          const data = [
            {'name': '百色芒果', 'value': 675},
            {'name': '圣女果', 'value': 1397},
            {'name': '牛心李', 'value': 318},
            {'name': '西林火姜', 'value': 101},
            {'name': '其他', 'value': 110}
          ]
          let total = 0;
          for (var i = 0; i < data.length; i++) {
            total += data[i].value
          }
          const tooltopOpiton = {
            color: ['#CC68FA', '#FF6438', '#35CDFD', '#FF7B7B', '#FFFE75', '#22FAA1'],
            title: {
              text: '总数',
              subtext: total,
              textStyle: {
                fontSize: 12,
                color: '#fff',
                align: 'center'
              },
              subtextStyle: {
                fontSize: 12,
                color: '#fff'
              },
              x: '22%',
              y: '33%'
            },
            grid: {
              bottom: 150,
              left: 100,
              right: '10%'
            },
            legend: {
              right: 'right',
              top: '-4%',
              textStyle: {
                color: '#f2f2f2',
                fontSize: 12
              },
              icon: 'pin',
              data,
              formatter: function (name) {
                for (let i = 0; i < data.length; i++) {
                  if (name === data[i].name) {
                    return `${name} ${(data[i].value / total).toFixed(2) * 100}% ${data[i].value}`
                  }
                }
              }
            },
            series: [
              {
                radius: ['40%', '70%'],
                center: ['30%', '50%'],
                type: 'pie',
                label: {
                  normal: {
                    show: false
                  },
                  emphasis: {
                    show: true
                  }
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                name: "信息统计",
                data
              }]
          }
          tooltipCharts.setOption(tooltopOpiton);
        }
      }

      const option = {
        // 自定义引导饼图
        tooltip: {
          show: true,
          trigger: 'item',
          triggerOn: 'mousemove',
          enterable: true,
          transitionDuration: 1,
          formatter: function(params) {
            const tipHtml = '<div style="height:150px;width:266px;padding: 10px;background:#2369D3;box-shadow:0 0 1px 1px #14CBF5">' +
              '    <div style="height: 15px;">产量分析 <span style="font-size: 10px">(吨)</span></div>' +
              '    <div id="tooltipPieId" style="height:135px;width:100%"></div>' +
              '</div>';
            setTimeout(function() {
              tooltipCharts();
            }, 10);
            return tipHtml;
          }
        },
        geo: {
          map: this.areaName,
          show: true,
          label: {
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#7868EC',
              borderColor: '#BCC5EA',
              borderWidth: 2,
              shadowColor: '#5AB2FE',
              shadowBlur: 5
            }
          },
          zoom: 1.2
        },
        series: [{
          type: 'map',
          map: this.areaName,
          geoIndex: 1,
          aspectScale: 0.75,
          zoom: 1.2,
          markPoint: {
            symbol: 'image://https://s2.ax1x.com/2019/05/20/Extm4S.png',
            symbolSize: 40
          },
          label: {
            normal: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 20
              }
            },
            emphasis: {
              textStyle: {
                color: '#fff',
                fontSize: 20
              }
            }
          },
          roam: false,
          itemStyle: {
            normal: {
              areaColor: '#7868EC',
              borderColor: '#BCC5EA',
              borderWidth: 2
            },
            emphasis: {
              areaColor: '#328DDF',
              borderColor: '#BCC5EA',
              shadowBlur: 8
            }
          },
          data
        }, {
          name: '企业图片',
          type: 'scatter',
          coordinateSystem: 'geo',
          label: {
            normal: {
              show: true,
              formatter: '{b|{b}}',
              rich: {
                b: {
                  height: 30,
                  padding: [0, 10],
                  align: 'center',
                  backgroundColor: '#1375C9',
                  borderColor: '#0ECAF7',
                  borderRadius: '5px',
                  color: '#fff'
                }
              }
            }
          },
          zlevel: 6,
          data: convertData(data)
        }]
      }
      this.myChart.setOption(option);
      let index = 0;
      setInterval(() => {
        this.myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: index
        })
        index++
        if (index >= data.length) {
          index = 0
        }
      }, 3000)
    })
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?8d290310